<template>
    <div id="academic">
        <sidebar :content="sidebarData"></sidebar>
        <router-view></router-view>
    </div>
</template>
<script>
import sidebar from "@/components/sidebar";
export default {
  name: "academic",
  components: {
    sidebar
  },
  data() {
    return {
      sidebarData: {
        title: "学术交流",
        sub: [
          {
            title: "研究动态",
            sub: [],
            url: "/academic/trends"
          },
          {
            title: "观点摘要",
            sub: [],
            url: "/academic/opinion"
          }
        ]
      }
    };
  }
};
</script>
<style lang="scss" scoped>
#academic {
  display: flex;
    width: 80%;
    margin: 0 auto;
    padding: 40px 0 160px 0;
}
</style>


